import { useEffect, useMemo, useRef, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Paper, Tooltip, Typography, useTheme,
    IconButton,
    Avatar,
    Autocomplete, CircularProgress, TextField, Stack, Button, Icon
} from "@mui/material";
import { DataGrid, GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import Grid from '@mui/material/Grid2';
import { FranquiaService, ICreateEscalacaoListaAmericana, IDadosEscalacao, IDadosEscalacaoListaAmericana, IDadosPosicaoJogador, IDadosRetornoEscalacaoFranquia, IDadosRetornoEscalacaoFranquiaListaAmericana, IDadosTitulares, IDetalheFranquia, IDetalheFranquiaEscalacao, IListaDadosEscalacao, IListaEscalacao, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { IDadosJogosNba, IDadosPosicaoConversao, LigaService } from "../../shered/services/api/liga/LigaService";
import { Loading } from "../../shered/components/loading/Loading";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { DisputaService, IDadosCalendario } from "../../shered/services/api/disputa/DisputaService";
import { ptBR } from '@mui/x-data-grid/locales';
import { ArrowDropDown, ArrowDropUp, ArrowLeft, ArrowRight } from "@mui/icons-material";


//"url('https://th.bing.com/th/id/R.c854e2b63ae50c9051c15c13b5c20079?rik=7FDghLisC%2bqcUA&riu=http%3a%2f%2fwww.tokkoro.com%2fpicsup%2f1497094-basketball.jpg&ehk=qYAmqGt%2bOqRJkMI2Q4AaL25dgtxzO49fI9kn1xkdZGs%3d&risl=&pid=ImgRaw&r=0') ",

export type TDropOptionsJogador = {
    codigo: number;
    label: string;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    foto: string;
}

export const DetalheDeEscalacao: React.FC = () => {
    const theme = useTheme();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const user = CookieService.get("access_user");
    const refTab = useRef<any>(null);
    const { themeName } = useAppThemeContext();
    const { id } = useParams<"id">();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { logout } = useAuthContext();
    const [removeLoading, setRemoveLoading] = useState(false);
    //const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    //const [rows, setRows] = useState<IDetalheDraftPicksTable[]>([]);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [redirecionar, setRedirecionar] = useState("");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [escalacaoRows, setEscalacaoRows] = useState<IDadosRetornoEscalacaoFranquiaListaAmericana[]>([]);
    const [listaJogadoresFranquia, setListaJogadoresFranquia] = useState<IDadosRetornoEscalacaoFranquiaListaAmericana[]>([]);
    const [lstCodTitulares, setLstCodTitulares] = useState<IDadosTitulares[]>([]);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptionsJogador[]>([]);
    const [opcoesJogadorSegReserva, setOpcoesJogadorSegReserva] = useState<TDropOptionsJogador[]>([]);
    const [opcoesJogadorPriReserva, setOpcoesJogadorPriReserva] = useState<TDropOptionsJogador[]>([]);
    const [listaTodosJogadores, setListaTodosJogadores] = useState<TDropOptionsJogador[]>([]);
    const [showImagemFranquia] = useState<any>("../../../../semimagemescudo.png");

    // const [listaEscolhidos, setListaEscolhidos] = useState<TDropOptionsJogador[]>([]);

    const [reserva1_6, setReserva1_6] = useState<IDadosPosicaoJogador>();
    const [reserva2_6, setReserva2_6] = useState<IDadosPosicaoJogador>();
    const [reserva1_5, setReserva1_5] = useState<IDadosPosicaoJogador>();
    const [reserva2_5, setReserva2_5] = useState<IDadosPosicaoJogador>();
    const [reserva1_7, setReserva1_7] = useState<IDadosPosicaoJogador>();
    const [reserva2_7, setReserva2_7] = useState<IDadosPosicaoJogador>();
    const [reserva1_C, setReserva1_C] = useState<IDadosPosicaoJogador>();
    const [reserva2_C, setReserva2_C] = useState<IDadosPosicaoJogador>();
    const [reserva1_PF, setReserva1_PF] = useState<IDadosPosicaoJogador>();
    const [reserva2_PF, setReserva2_PF] = useState<IDadosPosicaoJogador>();
    const [reserva1_SF, setReserva1_SF] = useState<IDadosPosicaoJogador>();
    const [reserva2_SF, setReserva2_SF] = useState<IDadosPosicaoJogador>();
    const [reserva1_PG, setReserva1_PG] = useState<IDadosPosicaoJogador>();
    const [reserva2_PG, setReserva2_PG] = useState<IDadosPosicaoJogador>();
    const [reserva1_SG, setReserva1_SG] = useState<IDadosPosicaoJogador>();
    const [reserva2_SG, setReserva2_SG] = useState<IDadosPosicaoJogador>();
    const [reserva1_RC, setReserva1_RC] = useState<IDadosPosicaoJogador>();
    const [reserva2_RC, setReserva2_RC] = useState<IDadosPosicaoJogador>();
    const [reserva1_RF, setReserva1_RF] = useState<IDadosPosicaoJogador>();
    const [reserva2_RF, setReserva2_RF] = useState<IDadosPosicaoJogador>();
    const [reserva1_RG, setReserva1_RG] = useState<IDadosPosicaoJogador>();
    const [reserva2_RG, setReserva2_RG] = useState<IDadosPosicaoJogador>();

    const [imagem6, setImagem6] = useState("");
    const [imagem7, setImagem7] = useState("");
    const [imagem5, setImagem5] = useState("");
    const [imagemC, setImagemC] = useState("");
    const [nome6, setNome6] = useState("");
    const [nome7, setNome7] = useState("");
    const [nomeSG, setNomeSG] = useState("");
    const [nomeSF, setNomeSF] = useState("");
    const [nomePG, setNomePG] = useState("");
    const [nomePF, setNomePF] = useState("");
    const [nomeC, setNomeC] = useState("");
    const [nome5, setNome5] = useState("");

    const [nomeRG, setNomeRG] = useState("");
    const [nomeRF, setNomeRF] = useState("");
    const [nomeRC, setNomeRC] = useState("");
    const [imagemRC, setImagemRC] = useState("");
    const [imagemRG, setImagemRG] = useState("");
    const [imagemRF, setImagemRF] = useState("");

    const [imagemPG, setImagemPG] = useState("");
    const [imagemSG, setImagemSG] = useState("");
    const [imagemPF, setImagemPF] = useState("");
    const [imagemSF, setImagemSF] = useState("");
    const [showTitular, setShowTitular] = useState(false);
    const [showReserva1, setReserva1] = useState(false);
    const [showReserva2, setReserva2] = useState(false);
    // const [showReserva3, setReserva3] = useState(false);
    const [showJogador6, setShowJogador6] = useState(false);
    const [showJogador7, setShowJogador7] = useState(false);
    const [showJogadorRG, setShowJogadorRG] = useState(false);
    const [showJogadorRF, setShowJogadorRF] = useState(false);
    const [showJogadorRC, setShowJogadorRC] = useState(false);
    const [selecionado, setSelecionado] = useState<string | undefined>("");
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [selectedIdCompleteR1, setSelectedIdCompleteR1] = useState<number | undefined>(0);
    const [selectedIdCompleteR2, setSelectedIdCompleteR2] = useState<number | undefined>(0);
    //    const [selectedIdComplete6, setSelectedIdComplete6] = useState<number | undefined>(0);
    const [minhaFranquia, setMinhaFranquia] = useState(false);
    const [nomeFranquia, setNomeFranquia] = useState("");
    const [franquia, setFranquia] = useState<IDetalheFranquia>();
    const [parametroDecrypt, setParametroDecrypt] = useState<string | undefined>("");

    const [posicao, setPosicao] = useState<string | undefined>("");
    const [dadosPosicoes, setDadosPosicoes] = useState<IDadosPosicaoConversao[]>([]);
    const [dadosEscalacao, setDadosEscalacao] = useState<IDadosRetornoEscalacaoFranquia>();
    const [dadosEscalacaoAmericana, setDadosEscalacaoAmericana] = useState<IDadosEscalacaoListaAmericana>();
    const [codigoCalendario, setCodigoCalendario] = useState<number>(0);
    const [codigoRodada, setCodigoRodada] = useState<number>(0);
    const [codigoFranquia, setCodigoFranquia] = useState<number>(0);

    const [dados6, setDados6] = useState<IDadosPosicaoJogador>();
    const [dados5, setDados5] = useState<IDadosPosicaoJogador>();
    const [dados7, setDados7] = useState<IDadosPosicaoJogador>();
    const [dadosPG, setDadosPG] = useState<IDadosPosicaoJogador>();
    const [dadosSG, setDadosSG] = useState<IDadosPosicaoJogador>();
    const [dadosPF, setDadosPF] = useState<IDadosPosicaoJogador>();
    const [dadosSF, setDadosSF] = useState<IDadosPosicaoJogador>();
    const [dadosC, setDadosC] = useState<IDadosPosicaoJogador>();
    const [dadosRF, setDadosRF] = useState<IDadosPosicaoJogador>();
    const [dadosRG, setDadosRG] = useState<IDadosPosicaoJogador>();
    const [dadosRC, setDadosRC] = useState<IDadosPosicaoJogador>();
    // const [listaJogadores, setListaJogadores] = useState<IDadosPosicaoJogador[]>();
    const [avatarPF, setAvatarPF] = useState<boolean>(false);
    const [avatarSG, setAvatarSG] = useState<boolean>(false);
    const [avatarF, setAvatarF] = useState<boolean>(false);
    const [avatarG, setAvatarG] = useState<boolean>(false);
    const [avatarC, setAvatarC] = useState<boolean>(false);
    const [avatarSF, setAvatarSF] = useState<boolean>(false);
    const [avatarPG, setAvatarPG] = useState<boolean>(false);
    const [avatar5, setAvatar5] = useState<boolean>(false);
    const [avatar6, setAvatar6] = useState<boolean>(false);
    const [avatar7, setAvatar7] = useState<boolean>(false);
    const [avatarRC, setAvatarRC] = useState<boolean>(false);
    const [avatarRF, setAvatarRF] = useState<boolean>(false);
    const [avatarRG, setAvatarRG] = useState<boolean>(false);
    const [travarEscalacao, setTravarEscalacao] = useState<boolean>(false);
    const [telaCopinha, setTelaCopinha] = useState<boolean>(false);
    const [lstJogosRodadaNba, setLstJogosRodadaNba] = useState<IDadosJogosNba[]>([]);
    const [codigoTipoEscalacao, setCodigoTipoEscalacao] = useState<number>(0);
    const [dadosCalendarioAnterior, setDadosCalendarioAnterior] = useState<IDadosCalendario>()
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: true,
        label: "",
        tipo: "success",
        mensagem: "Escalação realizada com sucesso!",
        display: "none",
        titulo: "Atenção"
    });

    const sectionStyle = {
        minWidth: "310px",
        backgroundImage:
            "url('../../../../../quadra_II.png') ",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: 'bottom',
        alignItems: "baseline",
        minHeight: "550px"

    };

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "1");
    }, [searchParams]);

    const codigoLisCrypt = UtilidadeService.crypt("0");
    useEffect(() => {
        setRemoveLoading(false);

        let parametros: string | undefined = "";
        if (id !== undefined) {
            parametros = UtilidadeService.decrypt(id.toString());
            if (parametros === "" || parametros === undefined) {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setIsLoading(false);

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Dados inválidos!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar(`/liga/calendario/${id}`);
                return;

            }
            setParametroDecrypt(parametros);
        }
        else {
            setRedirecionar("/dashboard");
        }
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0" || codigoLiga === undefined) {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("/dashboard");
            return;
        }

        setIsLoading(true);

        const rodada = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[0];
        const minhafranquia = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[3];
        const codCalendario = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[1];
        const codFranquia = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[2];
        const tipoEscalacao = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[4];
        const codTemporada = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[5];
        const copinha = parametros === undefined ? setRedirecionar("/dashboard") : parametros.split("/")[6] === "2";

        const fetchData = async () => {
            setIsLoading(false);
            let listaPosicoes: IDadosPosicaoConversao[] = [];
            setCodigoTipoEscalacao(Number(tipoEscalacao));
            setTelaCopinha(copinha === true);
            await LigaService.getDadosPosicaoConversaoPorLiga(Number(codigoLiga), Number(codTemporada))
                .then((result) => {
                    setIsLoading(false);
                    if (result.dado.length === 0) {
                        setShowModalMensagem(true);
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "warning",
                            mensagem: "Configuração da liga incompleto! Caso seja o comissário da liga, favor realizar o cadastro do tipo de escalação na aba Jogabilidade da Liga. Caso não seja, favor entrar em contato com o comissário.",
                            display: "none",
                            titulo: "Atenção"
                        });

                        setRedirecionar(`/liga/calendario/${codigoLisCrypt}`);
                        return;
                    }
                    setDadosPosicoes(result.dado);
                    setCodigoCalendario(Number(codCalendario));
                    setCodigoTemporada(Number(codTemporada));
                    setCodigoRodada(Number(rodada));
                    listaPosicoes = result.dado;

                }).catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response != undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });

                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados da escalação! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/liga/calendario/${codigoLisCrypt}`);
                        return;
                    }
                });

            await LigaService.getJogosNBAPorLigaTemporadaRodada(Number(codigoLiga), Number(codTemporada), Number(rodada), Number(codCalendario))
                .then((result) => {
                    setIsLoading(false);
                    const lst = result.dado;
                    let travar = false;
                    if (lst.length > 0) {
                        let firstList = lst.sort((a, b) => Number(new Date(a.data_Inicio)) - Number(new Date(b.data_Inicio))).filter(e => { return e !== null });
                        travar = user.administrador ? false : firstList[0].rodada_Iniciada;
                        setTravarEscalacao(travar);
                    }

                    setMinhaFranquia((minhafranquia === "true" && !travar) || user.administrador);
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response != undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados da escalação! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/liga/calendario/${codigoLisCrypt}`);
                        return;
                    }
                });
            setCodigoFranquia(Number(codFranquia));
            CarregarEscalacao(Number(codCalendario), Number(codFranquia), listaPosicoes, Number(tipoEscalacao));

            let lstDrop: TDropOptionsJogador[] = [];

            await FranquiaService.getByIdFranquia(Number(codFranquia))
                .then((result) => {
                    setIsLoading(false);
                    setNomeFranquia(result.dado.nome);
                    setFranquia(result.dado);
                    if (result.dado.franquia_Jogador.length > 0) {
                        lstDrop = result.dado.franquia_Jogador.filter(f => !f.fora_NBA && !f.contundido && Number(f.salario_1) !== 0).sort((a, b) => a.nome_Jogador > b.nome_Jogador ? 1 : -1)
                            .map((f, i) => ({ codigo: f.codigo_Jogador, label: f.nome_Jogador, foto: f.foto_Jogador, posicao_1: f.posicao_1, posicao_2: f.posicao_2, posicao_3: f.posicao_3 }));
                        setListaTodosJogadores(lstDrop);
                    }
                    setRemoveLoading(true);
                }).catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });

                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados da escalação! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/liga/calendario/${codigoLisCrypt}`);
                        return;
                    }
                });

            await LigaService.getJogosNBAPorLigaTemporadaRodada(Number(codigoLiga), Number(codTemporada), Number(rodada), Number(codCalendario))
                .then((result) => {
                    const lst = result.dado;
                    let filterList = lst.filter(e => { return e !== null });
                    setLstJogosRodadaNba(filterList);
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });

            setRemoveLoading(true);
        }
        fetchData();

    }, [pagina, codigoLiga, id]);


    const CarregarEscalacao = async (codCalendario: number, codigoFranquia: number, listaPosicoes: IDadosPosicaoConversao[], tipoEscalacao: number) => {

        if (tipoEscalacao !== 6) {
            await FranquiaService.getEscalacaoFranquia(codCalendario, codigoFranquia)
                .then((result) => {
                    setIsLoading(false);
                    let dadosRetornoEscalacao = result.dado
                    setDadosEscalacao(dadosRetornoEscalacao);
                    let escalacao = dadosRetornoEscalacao.escalacao;
                    escalacao.forEach(element => {
                        listaPosicoes.filter(w => w.codigo === element.codigo_Posicao_Conversao).forEach(pos => {
                            element.escalacao_Jogador.forEach(jog => {
                                if (tipoEscalacao === 2) {
                                    if (pos.posicao_Original.includes("6")) {
                                        if (jog.ordem === 1) {
                                            setDados6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagem6(jog.foto);
                                            setNome6(jog.nome);
                                            setAvatar6(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "G" && pos.posicao_Liga === "SG") {
                                        if (jog.ordem === 1) {
                                            setDadosSG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemSG(jog.foto);
                                            setNomeSG(jog.nome);
                                            setAvatarSG(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_SG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_SG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }


                                    }
                                    else if (pos.posicao_Original === "F" && pos.posicao_Liga === "SF") {
                                        if (jog.ordem === 1) {
                                            setDadosSF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemSF(jog.foto);
                                            setNomeSF(jog.nome);
                                            setAvatarSF(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_SF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_SF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }

                                    }
                                    else if (pos.posicao_Original === "F" && pos.posicao_Liga === "PF") {
                                        if (jog.ordem === 1) {
                                            setDadosPF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemPF(jog.foto);
                                            setNomePF(jog.nome);
                                            setAvatarPF(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_PF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_PF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "G" && pos.posicao_Liga === "PG") {
                                        if (jog.ordem === 1) {
                                            setDadosPG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemPG(jog.foto);
                                            setNomePG(jog.nome);
                                            setAvatarPG(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_PG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_PG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }

                                    }
                                    else if (pos.posicao_Original === "C" && pos.posicao_Liga === "C") {
                                        if (jog.ordem === 1) {
                                            setDadosC({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemC(jog.foto);
                                            setNomeC(jog.nome);
                                            setAvatarC(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_C({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_C({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                }
                                else if (tipoEscalacao === 5) {
                                    if (pos.posicao_Original.includes("6")) {
                                        if (jog.ordem === 1) {
                                            setDados6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagem6(jog.foto);
                                            setNome6(jog.nome);
                                            setAvatar6(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original.includes("7")) {
                                        if (jog.ordem === 1) {
                                            setDados7({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagem7(jog.foto);
                                            setNome7(jog.nome);
                                            setAvatar7(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_7({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_7({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "SG") {
                                        if (jog.ordem === 1) {
                                            setDadosSG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemSG(jog.foto);
                                            setNomeSG(jog.nome);
                                            setAvatarSG(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_SG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_SG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "SF") {
                                        if (jog.ordem === 1) {
                                            setDadosSF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemSF(jog.foto);
                                            setNomeSF(jog.nome);
                                            setAvatarSF(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_SF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_SF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "PF") {
                                        if (jog.ordem === 1) {
                                            setDadosPF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemPF(jog.foto);
                                            setNomePF(jog.nome);
                                            setAvatarPF(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_PF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_PF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "PG") {
                                        if (jog.ordem === 1) {
                                            setDadosPG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemPG(jog.foto);
                                            setNomePG(jog.nome);
                                            setAvatarPG(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_PG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_PG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "C" && pos.posicao_Liga === "C") {
                                        if (jog.ordem === 1) {
                                            setDadosC({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemC(jog.foto);
                                            setNomeC(jog.nome);
                                            setAvatarC(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_C({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_C({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                }
                                else {
                                    if (pos.posicao_Original.includes("6")) {
                                        if (jog.ordem === 1) {
                                            setDados6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagem6(jog.foto);
                                            setNome6(jog.nome);
                                            setAvatar6(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_6({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "SG") {
                                        if (jog.ordem === 1) {
                                            setDadosSG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemSG(jog.foto);
                                            setNomeSG(jog.nome);
                                            setAvatarSG(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_SG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_SG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "SF") {
                                        if (jog.ordem === 1) {
                                            setDadosSF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemSF(jog.foto);
                                            setNomeSF(jog.nome);
                                            setAvatarSF(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_SF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_SF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "PF") {
                                        if (jog.ordem === 1) {
                                            setDadosPF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemPF(jog.foto);
                                            setNomePF(jog.nome);
                                            setAvatarPF(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_PF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_PF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "PG") {
                                        if (jog.ordem === 1) {
                                            setDadosPG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemPG(jog.foto);
                                            setNomePG(jog.nome);
                                            setAvatarPG(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_PG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_PG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "C" && pos.posicao_Liga === "C") {
                                        if (jog.ordem === 1) {
                                            setDadosC({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemC(jog.foto);
                                            setNomeC(jog.nome);
                                            setAvatarC(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_C({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_C({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "C" && pos.posicao_Liga === "RC") {
                                        if (jog.ordem === 1) {
                                            setDadosRC({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemRC(jog.foto);
                                            setNomeRC(jog.nome);
                                            setAvatarRC(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_RC({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_RC({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "G " && pos.posicao_Liga === "RG") {
                                        if (jog.ordem === 1) {
                                            setDadosRG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemRG(jog.foto);
                                            setNomeRG(jog.nome);
                                            setAvatarRG(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_RG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_RG({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                    else if (pos.posicao_Original === "F " && pos.posicao_Liga === "RF") {
                                        if (jog.ordem === 1) {
                                            setDadosRF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: jog.foto,
                                                nome: jog.nome
                                            });
                                            setImagemRF(jog.foto);
                                            setNomeRF(jog.nome);
                                            setAvatarRF(true);
                                        }
                                        if (jog.ordem === 2) {
                                            setReserva1_RF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                        if (jog.ordem === 3) {
                                            setReserva2_RF({
                                                codigo_Jogador: jog.codigo_Jogador,
                                                codigo_Posicao: element.codigo_Posicao_Conversao,
                                                foto: "",
                                                nome: jog.nome
                                            });
                                        }
                                    }
                                }
                            })
                        })
                    });
                }).catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });

                            logout();
                            setRedirecionar("0");

                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar a escalação do time. Favor tentar novamente mais tarde e caso o problema persista, entrar em contato com a TI. ",
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
        else {
            await FranquiaService.getEscalacaoFranquiaListaAmericana(codCalendario, codigoFranquia)
                .then((result) => {
                    setIsLoading(false);
                    let dadosRetornoEscalacaoAmericana = result.dado;
                    setDadosEscalacaoAmericana(dadosRetornoEscalacaoAmericana);
                    setEscalacaoRows(dadosRetornoEscalacaoAmericana.reserva.sort((a, b) => a.ordem > b.ordem ? 1 : -1));
                    setListaJogadoresFranquia(dadosRetornoEscalacaoAmericana.jogadores);
                    let escalacao = dadosRetornoEscalacaoAmericana.escalacao;
                    escalacao.forEach(element => {
                        listaPosicoes.filter(w => w.codigo === element.codigo_Posicao_Conversao).forEach(pos => {
                            element.escalacao_Jogador.forEach(jog => {
                                if (pos.posicao_Original.includes("6")) {
                                    if (jog.ordem === 1) {
                                        lstCodTitulares.push({
                                            codigoJogador: jog.codigo_Jogador, posicao: "6"
                                        })
                                        //setLstCodTitulares([...lstCodTitulares, {}])
                                        setDados6({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: jog.foto,
                                            nome: jog.nome
                                        });
                                        setImagem6(jog.foto);
                                        setNome6(jog.nome);
                                        setAvatar6(true);
                                    }
                                    if (jog.ordem === 2) {
                                        setReserva1_6({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                    if (jog.ordem === 3) {
                                        setReserva2_6({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                }
                                else if (pos.posicao_Original === "G" && pos.posicao_Liga === "SG") {
                                    if (jog.ordem === 1) {

                                        lstCodTitulares.push({
                                            codigoJogador: jog.codigo_Jogador, posicao: "SG"
                                        })
                                        //setLstCodTitulares([...lstCodTitulares, {  }])
                                        setDadosSG({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: jog.foto,
                                            nome: jog.nome
                                        });
                                        setImagemSG(jog.foto);
                                        setNomeSG(jog.nome);
                                        setAvatarSG(true);
                                    }
                                    if (jog.ordem === 2) {
                                        setReserva1_SG({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                    if (jog.ordem === 3) {
                                        setReserva2_SG({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                }
                                else if (pos.posicao_Original === "F" && pos.posicao_Liga === "SF") {
                                    if (jog.ordem === 1) {
                                        lstCodTitulares.push({
                                            codigoJogador: jog.codigo_Jogador, posicao: "SF"
                                        })
                                        //setLstCodTitulares([...lstCodTitulares, { codigoJogador: jog.codigo_Jogador, posicao: "SF" }])
                                        setDadosSF({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: jog.foto,
                                            nome: jog.nome
                                        });
                                        setImagemSF(jog.foto);
                                        setNomeSF(jog.nome);
                                        setAvatarSF(true);
                                    }
                                    if (jog.ordem === 2) {
                                        setReserva1_SF({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                    if (jog.ordem === 3) {
                                        setReserva2_SF({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                }
                                else if (pos.posicao_Original === "F" && pos.posicao_Liga === "PF") {
                                    if (jog.ordem === 1) {
                                        lstCodTitulares.push({
                                            codigoJogador: jog.codigo_Jogador, posicao: "PF"
                                        });
                                        //setLstCodTitulares([...lstCodTitulares, { codigoJogador: jog.codigo_Jogador, posicao: "PF" }])
                                        setDadosPF({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: jog.foto,
                                            nome: jog.nome
                                        });
                                        setImagemPF(jog.foto);
                                        setNomePF(jog.nome);
                                        setAvatarPF(true);
                                    }
                                    if (jog.ordem === 2) {
                                        setReserva1_PF({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                    if (jog.ordem === 3) {
                                        setReserva2_PF({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                }
                                else if (pos.posicao_Original === "G" && pos.posicao_Liga === "PG") {
                                    if (jog.ordem === 1) {
                                        lstCodTitulares.push({
                                            codigoJogador: jog.codigo_Jogador, posicao: "PG"
                                        })
                                        //setLstCodTitulares([...lstCodTitulares, { codigoJogador: jog.codigo_Jogador, posicao: "PG" }])
                                        setDadosPG({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: jog.foto,
                                            nome: jog.nome
                                        });
                                        setImagemPG(jog.foto);
                                        setNomePG(jog.nome);
                                        setAvatarPG(true);
                                    }
                                    if (jog.ordem === 2) {
                                        setReserva1_PG({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                    if (jog.ordem === 3) {
                                        setReserva2_PG({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                }
                                else if (pos.posicao_Original.includes("5")) {
                                    if (jog.ordem === 1) {
                                        lstCodTitulares.push({
                                            codigoJogador: jog.codigo_Jogador, posicao: "5"
                                        })
                                        //setLstCodTitulares([...lstCodTitulares, { codigoJogador: jog.codigo_Jogador, posicao: "5" }])
                                        setDados5({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: jog.foto,
                                            nome: jog.nome
                                        });
                                        setImagem5(jog.foto);
                                        setNome5(jog.nome);
                                        setAvatar5(true);
                                    }
                                    if (jog.ordem === 2) {
                                        setReserva1_5({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                    if (jog.ordem === 3) {
                                        setReserva2_5({
                                            codigo_Jogador: jog.codigo_Jogador,
                                            codigo_Posicao: element.codigo_Posicao_Conversao,
                                            foto: "",
                                            nome: jog.nome
                                        });
                                    }
                                }                               
                                setLstCodTitulares(lstCodTitulares);
                            })
                        })
                    });
                }).catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });

                            logout();
                            setRedirecionar("0");

                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar a escalação do time. Favor tentar novamente mais tarde e caso o problema persista, entrar em contato com a TI. ",
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
    }

    const handleSave = async (dados: IListaDadosEscalacao) => {
        setIsLoading(true);
        setRemoveLoading(false);
        let lstDadosEscalacao: IDadosEscalacao[] = [];
        let lstJogadoresTitulares: IDetalheFranquiaEscalacao[] = [];

        if (dadosPosicoes.length === 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: `Posições não cadastradas para essa liga!`,
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        dadosPosicoes.forEach((posicao, i) => {
            let lstEscalacaoJogador: IDetalheFranquiaEscalacao[] = [];
            if (codigoTipoEscalacao === 2) {
                if (posicao.posicao_Original.includes("6")) {

                    if (dados6 != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dados6?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dados6?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_6 != null && reserva1_6?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_6?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_6 != null && reserva2_6?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_6?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dados6?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "C" && posicao.posicao_Liga === "C") {
                    if (dadosC != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosC?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosC?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_C != null && reserva1_C?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_C?.codigo_Jogador,
                            ordem: 2
                        });
                    }

                    if (reserva2_C != null && reserva2_C?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_C?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "G" && posicao.posicao_Liga === "SG") {

                    if (dadosSG != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosSG?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosSG?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_SG != null && reserva1_SG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_SG?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_SG != null && reserva2_SG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_SG?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    });
                }
                if (posicao.posicao_Original === "F" && posicao.posicao_Liga === "SF") {
                    if (dadosSF != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosSF?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosSF?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_SF != null && reserva1_SF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_SF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_SF != null && reserva2_SF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_SF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    });
                }
                if (posicao.posicao_Original === "F" && posicao.posicao_Liga === "PF") {
                    if (dadosPF != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosPF?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosPF?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_PF != null && reserva1_PF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_PF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_PF != null && reserva2_PF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_PF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "G" && posicao.posicao_Liga === "PG") {
                    if (dadosPG != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosPG?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosPG?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_PG != null && reserva1_PG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_PG?.codigo_Jogador,
                            ordem: 2
                        })
                    }
                    if (reserva2_PG != null && reserva2_PG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_PG?.codigo_Jogador,
                            ordem: 3
                        })
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
            }
            else if (codigoTipoEscalacao === 6) {
                if (posicao.posicao_Original.includes("6")) {
                    if (dados6 != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dados6?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dados6?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_6 != null && reserva1_6?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_6?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_6 != null && reserva2_6?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_6?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dados6?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original.includes("5")) {
                    if (dados5 != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dados5?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dados5?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_5 != null && reserva1_5?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_5?.codigo_Jogador,
                            ordem: 2
                        });
                    }

                    if (reserva2_5 != null && reserva2_5?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_5?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "G" && posicao.posicao_Liga === "SG") {

                    if (dadosSG != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosSG?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosSG?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_SG != null && reserva1_SG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_SG?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_SG != null && reserva2_SG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_SG?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    });
                }
                if (posicao.posicao_Original === "F" && posicao.posicao_Liga === "SF") {
                    if (dadosSF != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosSF?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosSF?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_SF != null && reserva1_SF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_SF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_SF != null && reserva2_SF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_SF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    });
                }
                if (posicao.posicao_Original === "F" && posicao.posicao_Liga === "PF") {
                    if (dadosPF != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosPF?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosPF?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_PF != null && reserva1_PF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_PF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_PF != null && reserva2_PF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_PF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "G" && posicao.posicao_Liga === "PG") {
                    if (dadosPG != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosPG?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosPG?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_PG != null && reserva1_PG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_PG?.codigo_Jogador,
                            ordem: 2
                        })
                    }
                    if (reserva2_PG != null && reserva2_PG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_PG?.codigo_Jogador,
                            ordem: 3
                        })
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: posicao.codigo,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
            }
            else if (codigoTipoEscalacao === 5) {
                if (posicao.posicao_Original.includes("6")) {

                    if (dados6 != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dados6?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dados6?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_6 != null && reserva1_6?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_6?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_6 != null && reserva2_6?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_6?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dados6?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original.includes("7")) {

                    if (dados6 != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dados7?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dados7?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_7 != null && reserva1_7?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_7?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_7 != null && reserva2_7?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_7?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dados7?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "C" && posicao.posicao_Liga === "C") {
                    if (dadosC != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosC?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosC?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_C != null && reserva1_C?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_C?.codigo_Jogador,
                            ordem: 2
                        });
                    }

                    if (reserva2_C != null && reserva2_C?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_C?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosC?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "SG") {

                    if (dadosSG != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosSG?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosSG?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_SG != null && reserva1_SG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_SG?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_SG != null && reserva2_SG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_SG?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosSG?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    });
                }
                if (posicao.posicao_Original === "SF") {
                    if (dadosSF != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosSF?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosSF?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_SF != null && reserva1_SF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_SF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_SF != null && reserva2_SF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_SF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosSF?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    });
                }
                if (posicao.posicao_Original === "PF") {
                    if (dadosPF != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosPF?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosPF?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_PF != null && reserva1_PF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_PF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_PF != null && reserva2_PF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_PF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosPF?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "PG") {
                    if (dadosPG != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosPG?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosPG?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_PG != null && reserva1_PG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_PG?.codigo_Jogador,
                            ordem: 2
                        })
                    }
                    if (reserva2_PG != null && reserva2_PG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_PG?.codigo_Jogador,
                            ordem: 3
                        })
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosPG?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
            }
            else {
                if (posicao.posicao_Original.includes("6")) {

                    if (dados6 != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dados6?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dados6?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_6 != null && reserva1_6?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_6?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_6 != null && reserva2_6?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_6?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dados6?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "C" && posicao.posicao_Liga === "C") {
                    if (dadosC != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosC?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosC?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_C != null && reserva1_C?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_C?.codigo_Jogador,
                            ordem: 2
                        });
                    }

                    if (reserva2_C != null && reserva2_C?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_C?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosC?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "SG") {

                    if (dadosSG != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosSG?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosSG?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_SG != null && reserva1_SG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_SG?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_SG != null && reserva2_SG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_SG?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosSG?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    });
                }
                if (posicao.posicao_Original === "SF") {
                    if (dadosSF != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosSF?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosSF?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_SF != null && reserva1_SF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_SF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_SF != null && reserva2_SF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_SF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosSF?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    });
                }
                if (posicao.posicao_Original === "PF") {
                    if (dadosPF != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosPF?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosPF?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_PF != null && reserva1_PF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_PF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_PF != null && reserva2_PF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_PF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosPF?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === "PG") {
                    if (dadosPG != null) {

                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosPG?.codigo_Jogador,
                            ordem: 1
                        });

                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosPG?.codigo_Jogador,
                            ordem: 1
                        });

                    }
                    if (reserva1_PG != null && reserva1_PG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_PG?.codigo_Jogador,
                            ordem: 2
                        })
                    }
                    if (reserva2_PG != null && reserva2_PG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_PG?.codigo_Jogador,
                            ordem: 3
                        })
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosPG?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === ("C") && posicao.posicao_Liga === "RC") {

                    if (dadosRC != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosRC?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosRC?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_RC != null && reserva1_RC?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_RC?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_RC != null && reserva2_RC?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_RC?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosRC?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === ("G") && posicao.posicao_Liga === "RG") {

                    if (dadosRG != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosRG?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosRG?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_RG != null && reserva1_RG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_RG?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_RG != null && reserva1_RG?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_RG?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosRG?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
                if (posicao.posicao_Original === ("F") && posicao.posicao_Liga === "RF") {

                    if (dadosRF != null) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: dadosRF?.codigo_Jogador,
                            ordem: 1
                        });
                        lstJogadoresTitulares.push({
                            codigo_Jogador: dadosRF?.codigo_Jogador,
                            ordem: 1
                        });
                    }
                    if (reserva1_RF != null && reserva1_RF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva1_RF?.codigo_Jogador,
                            ordem: 2
                        });
                    }
                    if (reserva2_RF != null && reserva2_RF?.codigo_Jogador !== 0) {
                        lstEscalacaoJogador.push({
                            codigo_Jogador: reserva2_RF?.codigo_Jogador,
                            ordem: 3
                        });
                    }
                    lstDadosEscalacao.push({
                        codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                        codigo_Franquia: Number(franquia?.codigo),
                        codigo_Posicao_Conversao: dadosRF?.codigo_Posicao,
                        codUsuCriacao: user.codUsuario,
                        escalacao_Jogador: lstEscalacaoJogador
                    })
                }
            }
        });


        let lstUniqueCodigos = new Set(lstJogadoresTitulares.map(a => a.codigo_Jogador));

        if (lstUniqueCodigos.size < lstJogadoresTitulares.length) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: `Existe posição com o mesmo jogador de titular`,
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (lstUniqueCodigos.size > 0 && lstUniqueCodigos.has(0)) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: `Favor informar um jogador para cada posição.`,
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        let validacao = true;
        let cont = 0

        for (let index = 0; index < lstDadosEscalacao.length; index++) {
            const f = lstDadosEscalacao[index];
            if (f.codigo_Posicao_Conversao === undefined) {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: `Existe posição não preenchida`,
                    display: "none",
                    titulo: "Atenção"
                });
                validacao = false;
                break;
            }
        }

        if (validacao) {
            if (codigoTipoEscalacao === 6) {
                let dadosSalvar: ICreateEscalacaoListaAmericana = {
                    codigo_Calendario: Number(parametroDecrypt?.split("/")[1]),
                    codigo_Franquia: Number(franquia?.codigo),
                    escalacao: lstDadosEscalacao,
                    reserva: escalacaoRows
                }

                await FranquiaService.CreateEscalacaoListaAmericana(dadosSalvar)
                    .then((result) => {
                        setIsLoading(false);
                        setRemoveLoading(true);
                        setShowModalMensagem(true);
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "success",
                            mensagem: "Escalação realizada com sucesso!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/liga/calendario/${codigoRodada}`);

                    }).catch((errors) => {
                        setIsLoading(false);
                        setRemoveLoading(true);
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }
                        else {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: "Não foi possível carregar os dados da escalação! Favor entrar em contato com a TI",
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/liga/calendario/${codigoLisCrypt}`);
                            return;
                        }
                    });
            }
            else {
                await FranquiaService.CreateEscalacao(lstDadosEscalacao)
                    .then((result) => {
                        setIsLoading(false);
                        setRemoveLoading(true);
                        setShowModalMensagem(true);
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "success",
                            mensagem: "Escalação realizada com sucesso!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/liga/calendario/${codigoRodada}`);

                    }).catch((errors) => {
                        setIsLoading(false);
                        setRemoveLoading(true);
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }
                        else {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: "Não foi possível carregar os dados da escalação! Favor entrar em contato com a TI",
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/liga/calendario/${codigoLisCrypt}`);
                            return;
                        }
                    });
            }

        }
    };

    // const handleDelete = (id: number) => {
    //     if (window.confirm("Realmente deseja apagar?")) {
    //         setRemoveLoading(true);
    //         setShowModalMensagem(true);
    //         setDadosModalMensagem({
    //             acao: true,
    //             label: "",
    //             tipo: "success",
    //             mensagem: "Excluído com sucesso",
    //             display: "none",
    //             titulo: "Sucesso"
    //         });
    //     }
    // };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {

            redirecionar.length === 1 ? navigate(-1) : navigate(redirecionar);
        }

    };

    let posicoes = ["C", "PG", "PF", "SF", "SG", "G", "F"]
    const handleSelecionarJogador = async (posicao: string, tipo: string) => {
        setSelectedIdComplete(0);
        setSelectedIdCompleteR1(0);
        setSelectedIdCompleteR2(0);
        if ((codigoTipoEscalacao === 1 || codigoTipoEscalacao === 5) && posicoes.includes(posicao)) {
            let lstJogadorPosicao = listaTodosJogadores.filter(f => (f.posicao_1 !== null
                && (f.posicao_1.toString().trim() === posicao
                    || (f.posicao_2 !== null && f.posicao_2.toString().trim() === posicao)
                    || (f.posicao_3 !== null && f.posicao_3.toString().trim() === posicao)))).map(m => m);

            setOpcoesAutoCompleteJogador(lstJogadorPosicao);
            setShowTitular(true);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(false);
            setShowJogador7(false);
            setShowJogadorRG(false);
            setShowJogadorRF(false);
            setShowJogadorRC(false);
            let posi = `${dadosPosicoes.find(f => (f.posicao_Original === posicao || f.posicao_Liga === posicao))?.posicao_Liga}`
            setSelecionado(`Posição - ${posi}`);
            setPosicao(codigoTipoEscalacao === 1 || codigoTipoEscalacao === 5 ? posicao : tipo);
            if (imagemPF != "") {
                setAvatarPF(true);
            }
        }
        else if (codigoTipoEscalacao === 6 && posicoes.includes(posicao)) {
            let lstJogadorPosicao = listaTodosJogadores.filter(f =>
                (posicao === "SF" || posicao === "PF") ? (f.posicao_1 !== null
                    && ((f.posicao_1.toString().trim() === "SF" || f.posicao_1.toString().trim() === "PF" || f.posicao_1.toString().trim() === "C")
                        || (f.posicao_2 !== null && (f.posicao_2.toString().trim() === "SF" || f.posicao_2.toString().trim() === "PF" || f.posicao_2.toString().trim() === "C"))
                        || (f.posicao_3 !== null && (f.posicao_3.toString().trim() === "SF" || f.posicao_3.toString().trim() === "PF" || f.posicao_3.toString().trim() === "C"))))
                    :
                    (posicao === "PG" || posicao === "SG") ? (f.posicao_1 !== null
                        && ((f.posicao_1.toString().trim() === "PG" || f.posicao_1.toString().trim() === "SG")
                            || (f.posicao_2 !== null && (f.posicao_2.toString().trim() === "PG" || f.posicao_2.toString().trim() === "SG"))
                            || (f.posicao_3 !== null && (f.posicao_3.toString().trim() === "PG" || f.posicao_3.toString().trim() === "SG"))))
                        :

                        (f.posicao_1 !== null
                            && (f.posicao_1.toString().trim() === posicao
                                || (f.posicao_2 !== null && f.posicao_2.toString().trim() === posicao)
                                || (f.posicao_3 !== null && f.posicao_3.toString().trim() === posicao)))).map(m => m);

            setOpcoesAutoCompleteJogador(lstJogadorPosicao);
            setShowTitular(true);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(false);
            setShowJogador7(false);
            setShowJogadorRG(false);
            setShowJogadorRF(false);
            setShowJogadorRC(false);
            let posi = `${dadosPosicoes.find(f => (f.posicao_Original === posicao || f.posicao_Liga === posicao))?.posicao_Original}`
            setSelecionado(`Posição - ${posi}`);
            setPosicao(codigoTipoEscalacao === 6 ? posicao : tipo);
            if (imagemPF != "") {
                setAvatarPF(true);
            }
        }
        else if (codigoTipoEscalacao === 2 && posicoes.includes(tipo)) {
            let lstJogadorPosicao = listaTodosJogadores.filter(f => (f.posicao_1 !== null
                && (f.posicao_1.toString().trim() === tipo
                    || (f.posicao_2 !== null && f.posicao_2.toString().trim() === tipo)
                    || (f.posicao_3 !== null && f.posicao_3.toString().trim() === tipo)))).map(m => m);

            setOpcoesAutoCompleteJogador(lstJogadorPosicao);
            setShowTitular(true);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(false);
            setShowJogadorRG(false);
            setShowJogadorRF(false);
            setShowJogadorRC(false);
            let posi = `${"POSIÇÃO " + dadosPosicoes.find(f => (f.posicao_Original === tipo))?.posicao_Original}`
            setSelecionado(`${posi}`);
            setPosicao(posicao);
            if (imagemPF != "") {
                setAvatarPF(true);
            }
        }

        else if (posicao === "6") {
            setShowTitular(false);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(true);
            setSelecionado("6º Jogador");
            setOpcoesAutoCompleteJogador(listaTodosJogadores);
            setPosicao("6")
        }
        else if (posicao === "5") {
            setShowTitular(false);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(true);
            setSelecionado("5º Jogador");
            setOpcoesAutoCompleteJogador(listaTodosJogadores);
            setPosicao("5")
        }
        else if (posicao === "7") {
            setShowTitular(false);
            setReserva1(true);
            setReserva2(true);
            setShowJogador7(true);
            setSelecionado("7º Jogador");
            setOpcoesAutoCompleteJogador(listaTodosJogadores)
            setPosicao("7")
        }
        else {

            setShowTitular(false);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(true);
            setSelecionado("Outros");
        }
    };

    const handleSelecionarJogador8Posicoes = async (posicao: string, tipo: string) => {
        setSelectedIdComplete(0);
        //setSelectedIdComplete6(0);
        setSelectedIdCompleteR1(0);
        setSelectedIdCompleteR2(0);
        // setSelectedIdCompleteRC(0);
        // setSelectedIdCompleteRG(0);
        // setSelectedIdCompleteRF(0);

        if (posicao === "RG") {
            setShowTitular(false);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(false);
            setShowJogadorRG(true);
            setShowJogadorRF(false);
            setShowJogadorRC(false);
            setSelecionado("RG");

            setOpcoesAutoCompleteJogador(listaTodosJogadores.filter(f => f.posicao_1 === "PG" || f.posicao_1 === "SG"
                || f.posicao_2 === "PG" || f.posicao_2 === "SG"
                || f.posicao_3 === "PG" || f.posicao_3 === "SG"
            ));
            setPosicao(posicao);
            if (imagemPF != "") {
                setAvatarPF(true);
            }
        }
        else if (posicao === "RF") {
            setShowTitular(false);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(false);
            setShowJogadorRG(false);
            setShowJogadorRF(true);
            setShowJogadorRC(false);
            setSelecionado("RF");

            setOpcoesAutoCompleteJogador(listaTodosJogadores.filter(f => f.posicao_1 === "PF" || f.posicao_1 === "SF"
                || f.posicao_2 === "PF" || f.posicao_2 === "SF"
                || f.posicao_3 === "PF" || f.posicao_3 === "SF"
            ))
            setPosicao(posicao);
            if (imagemPF != "") {
                setAvatarPF(true);
            }
        }
        else if (posicao === "RC") {
            setShowTitular(false);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(false);
            setShowJogadorRG(false);
            setShowJogadorRF(false);
            setShowJogadorRC(true);
            setSelecionado("RC");
            let listaFiltrada = listaTodosJogadores.filter(f => (f.posicao_1 !== null && f.posicao_1.trim() === "C")
                || (f.posicao_2 !== null && f.posicao_2.trim() === "C") || (f.posicao_3 !== null && f.posicao_3.trim() === "C"));

            setOpcoesAutoCompleteJogador(listaFiltrada);
            setPosicao("RC")
        }
        else {
            setShowTitular(false);
            setReserva1(true);
            setReserva2(true);
            setShowJogador6(true);
            setSelecionado("Outros");
        }
    };

    const handleCarregarDadosJogador = async (codigo: any) => {        
        let jaEscalado = lstCodTitulares.find(f => f.codigoJogador === codigo);

        if (jaEscalado !== undefined) {
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Jogador já escalado como titular!",
                display: "none",
                titulo: "Informação"
            });
            return;
        }
        setRemoveLoading(false);
        setSelectedIdCompleteR1(0);
        setSelectedIdCompleteR2(0);
        let list1 = opcoesAutoCompleteJogador.filter(f => f.codigo !== codigo);
        setOpcoesJogadorPriReserva(list1);
        let list2 = opcoesAutoCompleteJogador.filter(f => f.codigo !== codigo);
        setOpcoesJogadorSegReserva(list2);
        let codigoAnterior: number | undefined = 0;
        let dadosJogador = opcoesAutoCompleteJogador.find(f => f.codigo === codigo);
        let foto = dadosJogador?.foto !== undefined ? dadosJogador?.foto : "";
        let nome = dadosJogador?.label !== undefined ? dadosJogador?.label : "";
        let lstTitulares: IDadosTitulares[] = [];

        if (posicao === "6" && foto.length > 0) {
            lstTitulares.push({
                codigoJogador: codigo,
                posicao: "6"
            })

            codigoAnterior = dados6?.codigo_Jogador;
            setDados6({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original.includes("6")) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original.includes("6"))?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagem6(foto);
            setNome6(nome);
            setAvatar6(true);
        }
        else if (posicao === "5" && foto.length > 0) {
            lstTitulares.push({
                codigoJogador: codigo,
                posicao: "5"
            })
            codigoAnterior = dados5?.codigo_Jogador;
            setDados5({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original.includes("5")) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original.includes("5"))?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagem5(foto);
            setNome5(nome);
            setAvatar5(true);
        }
        else if (posicao === "7" && foto.length > 0) {
            codigoAnterior = dados7?.codigo_Jogador;
            setDados7({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original.includes("7")) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original.includes("7"))?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagem7(foto);
            setNome7(nome);
            setAvatar7(true);
        }
        else if (posicao === "PG" && foto.length > 0) {
            lstTitulares.push({
                codigoJogador: codigo,
                posicao: "PG"
            })
            codigoAnterior = dadosPG?.codigo_Jogador;
            let pos = (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0;
            setDadosPG({
                codigo_Jogador: codigo,
                codigo_Posicao: pos,
                foto: foto,
                nome: nome
            })
            setImagemPG(foto);
            setNomePG(nome);
            setAvatarPG(true);
        }
        else if (posicao === "SF" && foto.length > 0) {

            lstTitulares.push({
                codigoJogador: codigo,
                posicao: "SF"
            })
            codigoAnterior = dadosSF?.codigo_Jogador;
            setDadosSF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagemSF(foto);
            setNomeSF(nome);
            setAvatarSF(true);
        }
        else if (posicao === "PF" && foto.length > 0) {

            lstTitulares.push({
                codigoJogador: codigo,
                posicao: "PF"
            })
            codigoAnterior = dadosPF?.codigo_Jogador;
            setDadosPF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagemPF(foto);
            setNomePF(nome);
            setAvatarPF(true);
        }
        else if (posicao === "SG" && foto.length > 0) {

            lstTitulares.push({
                codigoJogador: codigo,
                posicao: "SG"
            })
            codigoAnterior = dadosSG?.codigo_Jogador;
            setDadosSG({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagemSG(foto);
            setNomeSG(nome);
            setAvatarSG(true);
        }
        else if (posicao === "C" && foto.length > 0) {
            codigoAnterior = dadosC?.codigo_Jogador;
            setDadosC({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagemC(foto);
            setNomeC(nome);
            setAvatarC(true);
        }
        else if (posicao === "RC" && foto.length > 0) {
            setDadosRC({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Liga === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Liga === posicao)?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagemRC(foto);
            setNomeRC(nome);
            setAvatarRC(true);
        }
        else if (posicao === "RG" && foto.length > 0) {
            setDadosRG({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Liga === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Liga === posicao)?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagemRG(foto);
            setNomeRG(nome);
            setAvatarRG(true);
        }
        else if (posicao === "RF" && foto.length > 0) {
            setDadosRF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Liga === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Liga === posicao)?.codigo : 0,
                foto: foto,
                nome: nome
            })
            setImagemRF(foto);
            setNomeRF(nome);
            setAvatarRF(true);
        }
        if (codigoTipoEscalacao === 6) {
            await handleRemoverTitulares(codigo, codigoAnterior, lstTitulares, listaJogadoresFranquia);
        }
        setRemoveLoading(true);
    }

    const handleRemoverTitulares = async (codigo: number, codigoAnterior: number | undefined, lstCodigoTitular: IDadosTitulares[], listaOriginal: IDadosRetornoEscalacaoFranquiaListaAmericana[]) => {
        let newEscalacaoReservas = escalacaoRows.filter(f => f.codigo_Jogador !== codigo);       
        if(lstCodigoTitular[0] !== undefined){
        setLstCodTitulares([...lstCodTitulares.filter(f => f.posicao !== lstCodigoTitular[0].posicao), {
            codigoJogador: lstCodigoTitular[0].codigoJogador,
            posicao: lstCodigoTitular[0].posicao
        }
        ]);
    }
        let lstCodigos: number[] = [];
        //let teste = lstCodTitulares.length > 0 ? lstCodTitulares.forEach((f) => { lstCodigos.push(Number(f.codigoJogador)) }) : [];

        lstCodigos.push(codigo);

        if (lstCodigoTitular.length > 0) {           
            lstCodTitulares.filter(f => f.codigoJogador !== codigoAnterior).forEach(f => lstCodigos.push(f.codigoJogador));
            let lstReservas = listaOriginal.filter(f => !lstCodigos.includes(f.codigo_Jogador));
            newEscalacaoReservas = lstReservas !== undefined ? lstReservas : []

        }
        else {
            let antigoTitular = listaOriginal.find(f => f.codigo_Jogador === codigoAnterior);
            if (antigoTitular !== undefined) {
                newEscalacaoReservas.push(antigoTitular);
            }
        }

        newEscalacaoReservas.forEach((f, i) => { f.ordem = (i + 1) });
        setTimeout(() => {
            setEscalacaoRows(newEscalacaoReservas.sort((a, b) => a.ordem > b.ordem ? 1 : -1));
        }, 800);
    }

    const handleCarregarDadosJogadorReserva1 = (codigo: any) => {
        setRemoveLoading(false);

        let list1 = opcoesJogadorPriReserva.filter(f => f.codigo !== codigo);
        //let list1 = opcoesJogadorPriReserva;
        setOpcoesJogadorPriReserva(list1);
        let list2 = opcoesJogadorPriReserva.filter(f => f.codigo !== codigo);
        //let list2 = opcoesJogadorPriReserva;
        setOpcoesJogadorSegReserva(list2);

        let dadosJogador = opcoesAutoCompleteJogador.find(f => f.codigo === codigo);
        let nome = dadosJogador?.label !== undefined ? dadosJogador?.label : "";

        if (posicao === "6" && nome.length > 0) {
            setReserva1_6({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "5" && nome.length > 0) {
            setReserva1_5({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "7" && nome.length > 0) {
            setReserva1_7({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "PG" && nome.length > 0) {
            setReserva1_PG({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "SF" && nome.length > 0) {
            setReserva1_SF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "PF" && nome.length > 0) {
            setReserva1_PF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "SG" && nome.length > 0) {
            setReserva1_SG({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "C" && nome.length > 0) {
            setReserva1_C({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "RC" && nome.length > 0) {
            setReserva1_RC({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            })
        }
        else if (posicao === "RG" && nome.length > 0) {
            setReserva1_RG({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            })
        }
        else if (posicao === "RF" && nome.length > 0) {
            setReserva1_RF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            })
        }
        setRemoveLoading(true);
    }

    const handleCarregarDadosJogadorReserva2 = (codigo: any) => {
        setRemoveLoading(false);

        let list1 = opcoesJogadorPriReserva.filter(f => f.codigo !== codigo);
        //let list1 = opcoesJogadorPriReserva;
        setOpcoesJogadorPriReserva(list1);
        let list2 = opcoesJogadorPriReserva.filter(f => f.codigo !== codigo);
        //let list2 = opcoesJogadorPriReserva;
        setOpcoesJogadorSegReserva(list2);

        let dadosJogador = opcoesAutoCompleteJogador.find(f => f.codigo === codigo);
        let nome = dadosJogador?.label !== undefined ? dadosJogador?.label : "";
        if (posicao === "6" && nome.length > 0) {
            setReserva2_6({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "5" && nome.length > 0) {
            setReserva2_5({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "7" && nome.length > 0) {
            setReserva2_7({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "PG" && nome.length > 0) {
            setReserva2_PG({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "SF" && nome.length > 0) {
            setReserva2_SF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "PF" && nome.length > 0) {
            setReserva2_PF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "SG" && nome.length > 0) {
            setReserva2_SG({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "C" && nome.length > 0) {
            setReserva2_C({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "RC" && nome.length > 0) {
            setReserva2_RC({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "RG" && nome.length > 0) {
            setReserva2_RG({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        else if (posicao === "RF" && nome.length > 0) {
            setReserva2_RF({
                codigo_Jogador: codigo,
                codigo_Posicao: (dadosPosicoes !== null && dadosPosicoes.find(f => f.posicao_Original === posicao) !== undefined) ? dadosPosicoes.find(f => f.posicao_Original === posicao)?.codigo : 0,
                foto: "",
                nome: nome
            });
        }
        setRemoveLoading(true);
    }

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);

    const autoCompleteSelectedOptionR1 = useMemo(() => {
        if (!selectedIdCompleteR1) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdCompleteR1);
        if (!selectedIdCompleteR1) return null;

        return selectedOption;
    }, [selectedIdCompleteR1, opcoesAutoCompleteJogador]);

    const autoCompleteSelectedOptionR2 = useMemo(() => {
        if (!selectedIdCompleteR2) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdCompleteR2);
        if (!selectedIdCompleteR2) return null;

        return selectedOption;
    }, [selectedIdCompleteR2, opcoesAutoCompleteJogador]);

    const handleLimparPosicoes = () => {

        setSelectedIdComplete(0);
        setSelectedIdCompleteR1(0);
        setSelectedIdCompleteR2(0);

        if (posicao === "PF") {
            setAvatarPF(false);
            setImagemPF("");
            setNomePF("");
            setDadosPF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_PF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_PF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "SF") {
            setAvatarSF(false);
            setImagemSF("");
            setNomeSF("");
            setDadosSF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_SF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_SF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "C") {
            setAvatarC(false);
            setImagemC("");
            setNomeC("");
            setDadosC({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_C({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_C({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "PG") {
            setAvatarPG(false);
            setImagemPG("");
            setNomePG("");
            setDadosPG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_PG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_PG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "SG") {
            setAvatarSG(false);
            setImagemSG("");
            setNomeSG("");
            setDadosSG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_SG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_SG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "6") {
            setAvatar6(false);
            setImagem6("");
            setNome6("");
            setDados6({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_6({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_6({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "5") {
            setAvatar5(false);
            setImagem5("");
            setNome5("");
            setDados5({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_5({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_5({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "RC") {
            setAvatarRC(false);
            setImagemRC("");
            setNomeRC("");
            setDadosRC({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_RC({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_RC({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "RG") {
            setAvatarRG(false);
            setImagemRG("");
            setNomeRG("");
            setDadosRG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_RG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_RG({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "RF") {
            setAvatarRF(false);
            setImagemRF("");
            setNomeRF("");
            setDadosRF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_RF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_RF({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
        if (posicao === "7") {
            setAvatar7(false);
            setImagem7("");
            setNome7("");
            setDados7({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva1_7({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
            setReserva2_7({
                codigo_Jogador: 0,
                codigo_Posicao: 0,
                foto: "",
                nome: ""
            });
        }
    }

    const handleLimparTodasPosicoes = async () => {
        setSelectedIdComplete(0);
        setSelectedIdCompleteR1(0);
        setSelectedIdCompleteR2(0);
        setAvatarPF(false);
        setImagemPF("");
        setNomePF("");
        setDadosPF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_PF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_PF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatarSF(false);
        setImagemSF("");
        setNomeSF("");
        setDadosSF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_SF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_SF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatarC(false);
        setImagemC("");
        setNomeC("");
        setDadosC({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_C({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_C({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatarPG(false);
        setImagemPG("");
        setNomePG("");
        setDadosPG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_PG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_PG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatarSG(false);
        setImagemSG("");
        setNomeSG("");
        setDadosSG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_SG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_SG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatar6(false);
        setImagem6("");
        setNome6("");
        setDados6({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_6({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_6({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatar5(false);
        setImagem5("");
        setNome5("");
        setDados5({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_5({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_5({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatarRC(false);
        setImagemRC("");
        setNomeRC("");
        setDadosRC({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_RC({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_RC({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatarRG(false);
        setImagemRG("");
        setNomeRG("");
        setDadosRG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_RG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_RG({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setAvatarRF(false);
        setImagemRF("");
        setNomeRF("");
        setDadosRF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_RF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_RF({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setAvatar7(false);
        setImagem7("");
        setNome7("");
        setDados7({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva1_7({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });
        setReserva2_7({
            codigo_Jogador: 0,
            codigo_Posicao: 0,
            foto: "",
            nome: ""
        });

        setLstCodTitulares([]);        
        setEscalacaoRows(listaJogadoresFranquia);
    }

    const handleImportarEscalacao = async () => {        
        let rodadaAnterior = codigoRodada - 1;
        if (rodadaAnterior <= 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: `Não é possível importar a escalação na primeira rodada!`,
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        //Number(codigoLiga)

        await DisputaService.getCalendarioAnterior(Number(codigoLiga), codigoTemporada, rodadaAnterior, codigoFranquia)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                let dadosRetorno = result.dado;
                if (dadosRetorno !== undefined) {
                    setDadosCalendarioAnterior(dadosRetorno);
                    CarregarEscalacao(Number(dadosRetorno.codigo), codigoFranquia, dadosPosicoes, codigoTipoEscalacao);
                }               

            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });

    }

    useEffect(() => {
        if (refTab.current !== null && UtilidadeService.isMobile()) {
            refTab.current.focus();
        }
    })

    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );

    const columnsJogosNBA: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            width: 90,
            //flex: 1,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'data_Inicio',
            headerName: 'DATA',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            editable: false,
            type: "date",
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 100 : 180,
            valueFormatter: (params) => params.value
        },
        {
            field: 'nome_Franquia_NBA_Mandante',
            headerName: 'MANDANTE',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 80 : 280,
            editable: false,
            align: 'right',
            headerAlign: 'right',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        <span style={{
                            opacity: !params.row.mandante_Valido ? "0.7" : "1",
                            color: !params.row.mandante_Valido ? "#fbc02d" : "auto"
                        }}>
                            {params.row.nome_Franquia_NBA_Mandante}
                        </span>
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia_NBA_Mandante',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) =>
                <img src={params.value !== null ? params.value : showImagemFranquia} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: '-',
            headerName: '',
            width: 90,
            //flex: 1,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center",
            renderCell: (params) => " X "
        },
        {
            field: 'logo_Franquia_NBA_Visitante',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) =>
                <img src={params.value !== null ? params.value : showImagemFranquia} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'nome_Franquia_NBA_Visitante',
            headerName: 'VISITANTE',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 80 : 280,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        <span style={{
                            opacity: !params.row.visitante_Valido ? "0.7" : "1",
                            color: !params.row.visitante_Valido ? "#fbc02d" : "auto", paddingLeft: '5px'
                        }}>
                            {params.row.nome_Franquia_NBA_Visitante}
                        </span>

                    </Box>
                );
            },
        },
    ];

    const columnsEscalacao: GridColDef[] = [
        {
            field: 'codigo_Jogador',
            headerName: 'CÓDIGO',
            width: 90,
            //flex: 1,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'ordem',
            headerName: UtilidadeService.isMobile() ? "#" : 'ORDEM',
            width: UtilidadeService.isMobile() ? 60 : 90,
            //flex: 1,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center",
            sortable: false
        },
        {
            field: 'actions',
            headerName: '',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            sortable: false,
            width: UtilidadeService.isMobile() ? 65 : 120,
            getActions: (params) => [
                <GridActionsCellItem
                    sx={{ padding: UtilidadeService.isMobile() ? 0 : 1 }}
                    icon={
                        <Tooltip title="Abaixo">
                            {params.row.ordem < escalacaoRows.length ? (
                                <ArrowDropDown sx={{ color: "#66bb6a", fontSize: 28 }} />
                            ) : <></>
                            }
                        </Tooltip>}
                    label="Abaixo"
                    onClick={() => handleAlterarOrdem(params.row, 1)}
                />,
                <GridActionsCellItem
                    sx={{ padding: UtilidadeService.isMobile() ? 0 : 1 }}
                    icon={
                        <Tooltip title="Acima">
                            {params.row.ordem > 1 ? (
                                <ArrowDropUp sx={{ color: "#E91309", fontSize: 28 }} />
                            ) : <></>
                            }
                        </Tooltip>
                    }
                    label="Acima"
                    onClick={() => handleAlterarOrdem(params.row, 2)}
                />
            ]
        },
        {
            field: 'foto_Jogador',
            headerName: UtilidadeService.isMobile() ? "" : 'FOTO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            editable: false,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ?
                <img src={params.value} alt={params.value} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        //currentTarget.style.borderRadius = "25%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "50px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "50px";
                    }}
                />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />,
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 130 : 250,
            editable: false,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        // {
        //     field: 'media_Minutos',
        //     headerName: UtilidadeService.isMobile() ? "MIN" : 'MINUTOS',
        //     headerClassName: 'super-app-theme--header',
        //     width: UtilidadeService.isMobile() ? 80 : 150,
        //     renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0,00",
        //     align: "center",
        //     headerAlign: "center",
        //     sortable: false

        // },
        // {
        //     field: 'peso_Total',
        //     headerName: "TOTAL",
        //     headerClassName: 'super-app-theme--header',
        //     width: UtilidadeService.isMobile() ? 80 : 150,
        //     renderCell: (params) => params.value !== null ? params.value.toFixed(3).replace(".", ",") : "0,000",
        //     align: "center",
        //     headerAlign: "center",
        //     sortable: false

        // },
        // {
        //     field: 'peso_Total_Minutos',
        //     headerName: 'FPM',
        //     headerClassName: 'super-app-theme--header',
        //     width: UtilidadeService.isMobile() ? 80 : 150,
        //     renderCell: (params) => params.value !== null ? params.value.toFixed(3).replace(".", ",") : "0,000",
        //     align: "center",
        //     headerAlign: "center",
        //     sortable: false
        // },
        {
            field: 'posicao_1',
            headerName: UtilidadeService.isMobile() ? "POS. 1" : 'POSIÇÃO 1',
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: "center",
            headerAlign: "center",
            width: UtilidadeService.isMobile() ? 90 : 150,
        },
        {
            field: 'posicao_2',
            headerName: UtilidadeService.isMobile() ? "POS. 2" : 'POSIÇÃO 2',
            headerClassName: 'super-app-theme--header',
            sortable: false,
            width: UtilidadeService.isMobile() ? 90 : 150,
            align: "center",
            headerAlign: "center",

        },
        {
            field: 'posicao_3',
            headerName: UtilidadeService.isMobile() ? "POS. 3" : 'POSIÇÃO 3',
            headerClassName: 'super-app-theme--header',
            sortable: false,
            width: UtilidadeService.isMobile() ? 90 : 150,
            align: "center",
            headerAlign: "center",

        },
    ];

    const handleAlterarOrdem = async (params: any, tipo: number) => {
        let to: number = 0;
        if (tipo === 1) {
            to = params.ordem + 1;
            setEscalacaoRows(moveObject(escalacaoRows, to, params.ordem));
        } else {
            to = params.ordem - 1;
            setEscalacaoRows(moveObject(escalacaoRows, to, params.ordem));
        }
    }

    const moveObject = (arr: IDadosRetornoEscalacaoFranquiaListaAmericana[], targetValue: any, newIndex: number) => {
        let target = arr.find(value => value["codigo"] === targetValue);
        const newArray = arr.filter(value => value["codigo"] != targetValue);
        if (target !== undefined) {
            newArray.splice(newIndex - 1, 0, target);
        }

        const result = newArray.map((m, i) => ({
            codigo: i + 1,
            codUsuCriacao: m.codUsuCriacao,
            codigo_Jogador: m.codigo_Jogador,
            dtCriacao: m.dtCriacao,
            foto_Jogador: m.foto_Jogador,
            nome_Jogador: m.nome_Jogador,
            ordem: i + 1,
            playOff: m.playOff,
            media_Minutos: m.media_Minutos,
            peso_Total: m.peso_Total,
            peso_Total_Minutos: m.peso_Total_Minutos,
            posicao_1: m.posicao_1,
            posicao_2: m.posicao_2,
            posicao_3: m.posicao_3,
            escalacao_Apta: m.escalacao_Apta
        }));

        return result;
    }

    // const handleAlterarPosicao = async (e: any, params: any, tipo: number, direcao: string) => {
    //     let atual = tipo === 1 ? params.posicao_1 : tipo === 2 ? params.posicao_2 : params.posicao_3;
    //     let futura = tipo === 1 && direcao === "D" ? params.posicao_2 : tipo === 3 && direcao === "E" ? params.posicao_2 :
    //         tipo === 2 && direcao === "E" ? params.posicao_1 : params.posicao_3;
    //     let alteracao = escalacaoRows.find(f => f.codigo === params.codigo);
    //     let newEscalacao = escalacaoRows.filter(f => f.codigo !== params.codigo);

    //     if (alteracao != null) {
    //         if (tipo === 1) {
    //             alteracao.posicao_1 = futura;
    //             alteracao.posicao_2 = atual;
    //             alteracao.posicao_3 = params.posicao_3;
    //         }
    //         else if (tipo === 3) {
    //             alteracao.posicao_1 = params.posicao_1;
    //             alteracao.posicao_2 = atual;
    //             alteracao.posicao_3 = futura;
    //         }
    //         else if (tipo === 2 && direcao === "E") {

    //             alteracao.posicao_1 = atual;
    //             alteracao.posicao_2 = futura;
    //             alteracao.posicao_3 = params.posicao_3;
    //         }
    //         else if (tipo === 2 && direcao === "D") {
    //             alteracao.posicao_1 = params.posicao_1;
    //             alteracao.posicao_2 = futura;
    //             alteracao.posicao_3 = atual;
    //         }
    //         newEscalacao.push(alteracao);
    //     }
    //     setEscalacaoRows(newEscalacao.sort((a, b) => a.codigo > b.codigo ? 1 : -1));
    // }

    return (
        <LayoutBaseDePagina
            titulo={`Escalação ${nomeFranquia}`}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={minhaFranquia}
                    mostrarBotaoNovo={false}
                    mostrarBotaoCancelar={true}
                    desabilitarBotaoSalvar={isLoading || !removeLoading}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => telaCopinha ? navigate(`/liga/copinha/calendario/${UtilidadeService.crypt((codigoRodada).toString())}`) : navigate(`/liga/calendario/${UtilidadeService.crypt((codigoRodada - 1).toString())}`)}
                    aoClicarEmCancelar={() => navigate(0)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container size={{ xs: 12, sm: 12 }} direction="row" padding={2} spacing={2} sx={{ width: UtilidadeService.isMobile() ? "calc(100% + 0px)" : "auto", margin: 0 }}>
                        {!removeLoading && <Loading />}
                        <Grid container size={{ xs: 12, sm: 12 }} >
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} paddingBottom={2}>
                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, paddingBottom: 1, fontWeight: 600 }}>{`Escalação ${minhaFranquia === true ? "Minha Franquia" : nomeFranquia} - Rodada: ${codigoRodada}`}</Typography>
                            </Grid>
                            <Grid size={{ xs: 6, sm: 6, md: 3 }} display={travarEscalacao || !minhaFranquia ? "none" : "flex"} justifyContent="center" justifyItems="center" >
                                <Button
                                    color="error"
                                    variant="contained"
                                    disableElevation
                                    onClick={() => handleLimparTodasPosicoes()}
                                    endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>cleaning_services</Icon>}>
                                    <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} >{UtilidadeService.isMobile() ? "Limpar" : "Limpar Escalação"}</span>
                                </Button>
                            </Grid>
                            <Grid size={{ xs: 6, sm: 6, md: 3 }}
                                display={(travarEscalacao || !minhaFranquia || codigoRodada === 1) ? "none" : "flex"} justifyContent="center" justifyItems="center" >
                                <Button
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    onClick={() => {handleLimparTodasPosicoes(); handleImportarEscalacao()}}
                                    endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>import_contacts</Icon>}>
                                    <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }} > {UtilidadeService.isMobile() ? "Importar" : "Importar Escalação"}</span>
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }} padding={0} margin={0}>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2} display="flex" sx={{ minHeight: "65vh;" }}  >
                            {(codigoTipoEscalacao === 1 || codigoTipoEscalacao === 2 || codigoTipoEscalacao === 5 || codigoTipoEscalacao === 6) ? (
                                <Grid container size={{ xs: 12, sm: 12, md: 2 }} display="flex" alignItems="center" justifyContent="center" >
                                    <Grid container size={{ xs: 6, sm: 6, md: 12 }} display="grid" alignItems="center" justifyContent="center" spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                        <Grid size={{ xs: 12, sm: 12 }}  >
                                            <IconButton onClick={() => handleSelecionarJogador("6", "6")}>
                                                {avatar6 === false ? <Avatar alt="6" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} >6º</Avatar>
                                                    : <Tooltip placement="top" title={nome6}><Avatar alt="6" src={imagem6} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                            </IconButton>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={UtilidadeService.isMobile() ? 12 : 20} >
                                            <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nome6}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={UtilidadeService.isMobile() ? 12 : 20} >
                                            <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva1_6?.nome}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={UtilidadeService.isMobile() ? 12 : 20} >
                                            <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva2_6?.nome}</Typography>
                                        </Grid>
                                    </Grid>
                                    {codigoTipoEscalacao === 5 && (
                                        <Grid container size={{ xs: 6, sm: 12 }} display="grid" alignItems="center" justifyContent="center" spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                            <Grid size={{ xs: 12, sm: 12 }}  >
                                                <IconButton onClick={() => handleSelecionarJogador("7", "7")}>
                                                    {avatar7 === false ? <Avatar alt="7" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} >7º</Avatar>
                                                        : <Tooltip placement="top" title={nome7}><Avatar alt="7" src={imagem7} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                                </IconButton>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={UtilidadeService.isMobile() ? 12 : 20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nome7}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={UtilidadeService.isMobile() ? 12 : 20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva1_7?.nome}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={UtilidadeService.isMobile() ? 12 : 20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva2_7?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            ) :
                                <>
                                    <Grid container size={{ xs: 12, sm: 2 }} display="grid" alignItems="center" justifyContent="center" direction="row" >
                                        <Grid container display="grid" spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                            <Grid size={{ xs: 12, sm: 12 }}  >
                                                <IconButton onClick={() => handleSelecionarJogador8Posicoes("RC", "RC")}>
                                                    {avatarRC === false ? <Avatar alt="RC" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} >RC</Avatar>
                                                        : <Tooltip placement="top" title={nomeRC}><Avatar alt="RC" src={imagemRC} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                                </IconButton>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomeRC}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva1_RC?.nome}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva2_RC?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container display="grid" spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                            <Grid size={{ xs: 12, sm: 12 }}  >
                                                <IconButton onClick={() => handleSelecionarJogador8Posicoes("RF", "RF")}>
                                                    {avatarRF === false ? <Avatar alt="RF" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} >RF</Avatar>
                                                        : <Tooltip placement="top" title={nomeRF}><Avatar alt="RF" src={imagemRF} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                                </IconButton>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomeRF}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva1_RF?.nome}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva2_RF?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container display="grid" spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                            <Grid size={{ xs: 12, sm: 12 }}  >
                                                <IconButton onClick={() => handleSelecionarJogador8Posicoes("RG", "RG")}>
                                                    {avatarRG === false ? <Avatar alt="RG" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} >RG</Avatar>
                                                        : <Tooltip placement="top" title={nomeRG}><Avatar alt="RG" src={imagemRG} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: 'darkGray', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                                </IconButton>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomeRG}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva1_RG?.nome}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} rowGap={20} >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, fontWeight: "bold" }}>{reserva2_RG?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            <Grid container size={{ xs: 12, sm: 4 }} display="flex" style={sectionStyle} paddingBottom={1} >
                                {codigoTipoEscalacao === 6 ?
                                    (
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="grid" justifyContent="center" justifyItems="center" paddingTop={3} >
                                            <IconButton onClick={() => handleSelecionarJogador("5", "5")}>
                                                {avatar5 === false ? <Avatar alt="5" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#73045b', fontWeight: "bold", color: "white" }} >5º</Avatar>
                                                    : <Tooltip placement="top" title={nome5}><Avatar alt="5" src={imagem5} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#73045b', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                            </IconButton>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} display="grid" justifyContent="center" >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nome5}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_5?.nome}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_5?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                    )
                                    : (
                                        <>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="grid" justifyContent="center" justifyItems="center" paddingTop={3} >
                                                <IconButton onClick={() => handleSelecionarJogador("C", "C")}>
                                                    {avatarC === false ? <Avatar alt="C" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#73045b', fontWeight: "bold", color: "white" }} >C</Avatar>
                                                        : <Tooltip placement="top" title={nomeC}><Avatar alt="C" src={imagemC} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#73045b', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                                </IconButton>
                                                <Grid size={{ xs: 12, sm: 12, md: 12 }} display="grid" justifyContent="center" >
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomeC}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_C?.nome}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_C?.nome}</Typography>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}

                                {(codigoTipoEscalacao === 1 || codigoTipoEscalacao === 5) ? (
                                    <>
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} >
                                            <Grid container size={{ xs: 6, sm: 6, md: 6 }} display="flex" paddingLeft={UtilidadeService.isMobile() ? 2 : 3} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                                <IconButton onClick={() => handleSelecionarJogador("PF", "PF")}>
                                                    {avatarPF === false ? <Avatar alt="PF" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#12460D', fontWeight: "bold", color: "white" }}>PF</Avatar>
                                                        : <Tooltip placement="top" title={nomePF}><Avatar alt="PF" src={imagemPF} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#12460D', fontWeight: "bold", color: "white" }} /></Tooltip>
                                                    }
                                                </IconButton>
                                                <Grid size={{ xs: 12, sm: 12, md: 12 }} display="grid"  >
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomePF}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_PF?.nome}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_PF?.nome}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 6, sm: 6, md: 6 }} display="flex" justifyContent="center" paddingLeft={UtilidadeService.isMobile() ? 4 : 6} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                                <IconButton onClick={() => handleSelecionarJogador("SF", "SF")}>
                                                    {avatarSF === false ? <Avatar alt="SF" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#4EA058', fontWeight: "bold", color: "white" }} >SF</Avatar>
                                                        : <Tooltip placement="top" title={nomeSF}><Avatar alt="SF" src={imagemSF} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#4EA058', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                                </IconButton>
                                                <Grid size={{ xs: 12, sm: 12, md: 12 }} display="grid" justifyContent="center">
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomeSF}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_SF?.nome}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_SF?.nome}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }}  >
                                            <Grid container size={{ xs: 6, sm: 6, md: 6 }} display="grid" justifyContent="center" paddingRight={UtilidadeService.isMobile() ? 5 : 0} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                                <IconButton onClick={() => handleSelecionarJogador("SG", "SG")}>
                                                    {avatarSG === false ? <Avatar alt="SG" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#0D1346', fontWeight: "bold", color: "white" }} >SG</Avatar>
                                                        : <Tooltip placement="top" title={nomeSG}><Avatar alt="SG" src={imagemSG} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#0D1346', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                                </IconButton>
                                                <Grid size={{ xs: 12, sm: 12, md: 12 }} display="grid" >
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomeSG}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_SG?.nome}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_SG?.nome}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 6, sm: 6, md: 6 }} display="flex" paddingLeft={UtilidadeService.isMobile() ? 5 : 7} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                                <IconButton onClick={() => handleSelecionarJogador("PG", "PG")}>
                                                    {avatarPG === false ? <Avatar alt="PG" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#0D29D5', fontWeight: "bold", color: "white" }} >PG</Avatar>
                                                        : <Tooltip placement="top" title={nomePG}><Avatar alt="PG" src={imagemPG} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#0D29D5', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                                </IconButton>
                                                <Grid size={{ xs: 12, sm: 12, md: 12 }} display="grid" justifyContent="start">
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomePG}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_PG?.nome}</Typography>
                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_PG?.nome}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>


                                    </>
                                ) :
                                    <Grid container size={12} display={"flex"} justifyContent={"center"}>
                                        <Grid container size={{ xs: 5, sm: 6, md: 6 }} display="flex" paddingLeft={UtilidadeService.isMobile() ? 0 : 1} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                            <IconButton onClick={() => handleSelecionarJogador("PF", "F")}>
                                                {avatarPF === false ? <Avatar alt="PF" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#12460D', fontWeight: "bold", color: "white" }}>F</Avatar>
                                                    : <Tooltip placement="top" title={nomePF}><Avatar alt="PF" src={imagemPF} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#12460D', fontWeight: "bold", color: "white" }} /></Tooltip>
                                                }
                                            </IconButton>
                                            <Grid size={{ xs: 11, sm: 12, md: 12 }} display="grid"  >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomePF}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_PF?.nome}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_PF?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={{ xs: 5, sm: 6, md: 6 }} display="flex" justifyContent="center" paddingLeft={UtilidadeService.isMobile() ? 4 : 6} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                            <IconButton onClick={() => handleSelecionarJogador("SF", "F")}>
                                                {avatarSF === false ? <Avatar alt="SF" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#4EA058', fontWeight: "bold", color: "white" }} >F</Avatar>
                                                    : <Tooltip placement="top" title={nomeSF}><Avatar alt="SF" src={imagemSF} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#4EA058', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                            </IconButton>
                                            <Grid size={{ xs: 11, sm: 12, md: 12 }} display="grid" justifyContent="center">
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomeSF}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_SF?.nome}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_SF?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={{ xs: 5, sm: 6, md: 6 }} display="grid" justifyContent="center" paddingRight={UtilidadeService.isMobile() ? 5 : 4} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                            <IconButton onClick={() => handleSelecionarJogador("SG", "G")}>
                                                {avatarSG === false ? <Avatar alt="SG" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#0D1346', fontWeight: "bold", color: "white" }} >G</Avatar>
                                                    : <Tooltip placement="top" title={nomeSG}><Avatar alt="SG" src={imagemSG} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#0D1346', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                            </IconButton>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} display="grid" >
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomeSG}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_SG?.nome}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_SG?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={{ xs: 5, sm: 6, md: 6 }} display="flex" paddingLeft={UtilidadeService.isMobile() ? 4 : 7} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                                            <IconButton onClick={() => handleSelecionarJogador("PG", "G")}>
                                                {avatarPG === false ? <Avatar alt="PG" sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#0D29D5', fontWeight: "bold", color: "white" }} >G</Avatar>
                                                    : <Tooltip placement="top" title={nomePG}><Avatar alt="PG" src={imagemPG} sx={{ height: theme.spacing(8), width: theme.spacing(8), bgcolor: '#0D29D5', fontWeight: "bold", color: "white" }} /></Tooltip>}
                                            </IconButton>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} display="grid" justifyContent="start">
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "#fbc02d", fontWeight: "bold" }}>{nomePG}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva1_PG?.nome}</Typography>
                                                <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, color: "black", fontWeight: "bold" }}>{reserva2_PG?.nome}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 6, md: 5 }} display={minhaFranquia ? "block" : "none"} >
                                <Grid container size={{ xs: 12, sm: 12 }} margin={2} width={"90%"}>
                                    {(showTitular || showJogador6 || showJogador7 || showJogadorRC || showJogadorRG || showJogadorRF) && (
                                        <Grid size={{ xs: 12, sm: 12 }} textAlign="center" alignContent="center" paddingBottom={2} >
                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{selecionado}</Typography>
                                            <hr />
                                        </Grid>
                                    )}
                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" justifyItems="start">
                                        {showTitular && !showJogador6 && !showJogador7 && !showJogadorRC && !showJogadorRG && !showJogadorRF && (<>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} display="flex" justifyContent={UtilidadeService.isMobile() ? "left" : "right"} paddingRight={2} paddingBottom={UtilidadeService.isMobile() ? 0 : 2}>
                                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, paddingBottom: UtilidadeService.isMobile() ? 0 : 1, fontWeight: 600 }}>Titular</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} paddingBottom={UtilidadeService.isMobile() ? 1 : 2}>
                                                <Autocomplete
                                                    autoFocus
                                                    openText="Abrir"
                                                    closeText="Fechar"
                                                    noOptionsText="Sem opções"
                                                    loadingText="Carregando..."
                                                    options={opcoesAutoCompleteJogador}
                                                    loading={isLoading}
                                                    disabled={isLoading}
                                                    value={autoCompleteSelectedOption}
                                                    size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                    onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); handleCarregarDadosJogador(newValue?.codigo) }}
                                                    popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Jogador"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 14 : 16
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </>
                                        )}
                                        {(showJogador6 || showJogador7 || showJogadorRC || showJogadorRG || showJogadorRF) && (<>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} display="flex" justifyContent={UtilidadeService.isMobile() ? "left" : "right"} paddingRight={2}>
                                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, paddingBottom: UtilidadeService.isMobile() ? 0 : 1, fontWeight: 600 }}>{selecionado}</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} paddingBottom={UtilidadeService.isMobile() ? 1 : 2}>
                                                <Autocomplete
                                                    openText="Abrir"
                                                    closeText="Fechar"
                                                    noOptionsText="Sem opções"
                                                    loadingText="Carregando..."
                                                    options={opcoesAutoCompleteJogador}
                                                    loading={isLoading}
                                                    disabled={isLoading}
                                                    value={autoCompleteSelectedOption}
                                                    size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                    onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); handleCarregarDadosJogador(newValue?.codigo) }}
                                                    popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Jogador"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </>)}
                                        {showReserva1 && (<>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} display="flex" justifyContent={UtilidadeService.isMobile() ? "left" : "right"} paddingRight={2} paddingBottom={UtilidadeService.isMobile() ? 0 : 2}>
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>1º Reserva</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} paddingBottom={UtilidadeService.isMobile() ? 1 : 2}>
                                                <Stack spacing={1}>
                                                    <Autocomplete
                                                        openText="Abrir"
                                                        closeText="Fechar"
                                                        noOptionsText="Sem opções"
                                                        loadingText="Carregando..."
                                                        options={opcoesJogadorPriReserva}
                                                        loading={isLoading}
                                                        disabled={isLoading}
                                                        value={autoCompleteSelectedOptionR1}
                                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                        onChange={(event, newValue) => { setSelectedIdCompleteR1(newValue?.codigo); handleCarregarDadosJogadorReserva1(newValue?.codigo) }}
                                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Jogador"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Stack>
                                            </Grid>
                                        </>)}
                                        {showReserva2 && (<>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} display="flex" justifyContent={UtilidadeService.isMobile() ? "left" : "right"} paddingRight={2} paddingBottom={UtilidadeService.isMobile() ? 0 : 2}>
                                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, paddingBottom: UtilidadeService.isMobile() ? 0 : 1, fontWeight: 600 }}>2º Reserva</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} paddingBottom={UtilidadeService.isMobile() ? 1 : 2}>
                                                <Stack spacing={1}>
                                                    <Autocomplete
                                                        openText="Abrir"
                                                        closeText="Fechar"
                                                        noOptionsText="Sem opções"
                                                        loadingText="Carregando..."
                                                        options={opcoesJogadorSegReserva}
                                                        loading={isLoading}
                                                        disabled={isLoading}
                                                        value={autoCompleteSelectedOptionR2}
                                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                        onChange={(event, newValue) => { setSelectedIdCompleteR2(newValue?.codigo); handleCarregarDadosJogadorReserva2(newValue?.codigo) }}
                                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Jogador"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Stack>
                                            </Grid>
                                        </>)}
                                        {(showReserva1 || showJogador6 || showJogador7 || showTitular || showReserva2) && (
                                            <Grid size={{ xs: 12, sm: 8, md: 8 }} marginTop={2} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                                <Button
                                                    ref={refTab}
                                                    color="primary"
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={() => handleLimparPosicoes()}
                                                    endIcon={<Icon>clear</Icon>}>
                                                    Limpar {selecionado}
                                                </Button>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {codigoTipoEscalacao === 6 && (
                            <Grid container size={{ xs: 12, sm: 12 }} paddingLeft={UtilidadeService.isMobile() ? 0 : 2} paddingBottom={3} paddingTop={3}>
                                <Grid size={{ xs: 12, sm: 12 }} >
                                    <Typography variant="h6">Escalação Reservas</Typography>
                                    <hr />
                                </Grid>
                                <Grid display={isLoading ? "flex" : "none"} size={{ xs: 12 }} margin={UtilidadeService.isMobile() ? 0 : 1} paddingBottom={UtilidadeService.isMobile() ? 0 : 1}>
                                    {!removeLoading && <Loading />}
                                </Grid>
                                <Box sx={{
                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                    '& .super-app-theme--header': {
                                        backgroundColor: theme.palette.common.black,
                                        color: theme.palette.common.white
                                    },
                                    '& .super-app.negative': {
                                        color: 'red',
                                        fontWeight: 'bold'
                                    },
                                    '& .super-app.positive': {
                                        color: themeName === "light" ? "black" : "auto",
                                    },
                                }}>
                                    <DataGrid
                                        getRowId={(rows) => rows.codigo_Jogador}
                                        rows={escalacaoRows}
                                        columns={columnsEscalacao}
                                        columnVisibilityModel={{ codigo_Jogador: false }}
                                        initialState={{
                                            pagination: {
                                                paginationModel: {
                                                    pageSize: 24,
                                                },
                                            },
                                        }}
                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                        pageSizeOptions={[24, 50, 100]}
                                        autoHeight
                                        slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                        disableRowSelectionOnClick
                                        disableColumnFilter
                                        disableColumnMenu
                                        sx={{
                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                        }}
                                    />
                                </Box>
                            </Grid>
                        )}
                        <Grid size={{ xs: 12, sm: 12 }} paddingLeft={UtilidadeService.isMobile() ? 0 : 2} marginTop={3}>
                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>JOGOS DA RODADA NBA</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="flex-start" paddingLeft={UtilidadeService.isMobile() ? 0 : 2}>
                            <Box sx={{
                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                '& .super-app-theme--header': {
                                    backgroundColor: theme.palette.common.black,
                                    color: theme.palette.common.white
                                },
                                '& .super-app.negative': {
                                    color: 'red',
                                    fontWeight: 'bold'
                                },
                                '& .super-app.positive': {
                                    color: themeName === "light" ? "black" : "auto",
                                },
                            }}>
                                <DataGrid
                                    getRowId={(rows) => rows.codigo}
                                    rows={lstJogosRodadaNba}
                                    columns={columnsJogosNBA}
                                    columnVisibilityModel={{ codigo: false }}
                                    disableColumnSelector
                                    hideFooterPagination
                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                    autoHeight
                                    slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                    disableRowSelectionOnClick
                                    disableColumnFilter
                                    disableColumnMenu
                                    sx={{
                                        fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </VForm >
        </LayoutBaseDePagina >
    );
}